import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    with: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '8px 0'
  },
  greyText: { color: theme.palette.grey[600] },
  filterText: { fontWeight: 600, color: theme.palette.grey[800] },
  primaryTitle: {
    margin: '15px 0px',
    color: theme.palette.text.primary,
    fontSize: 20
  },
  secondaryTitle: {
    color: theme.palette.text.primary,
    fontSize: 18,
    margin: '10px 0px'
  },
  Row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8
  },
  check: { marginRight: 4 },
  form: { marginTop: 4 },
  showMoreBtn: { paddingLeft: 0 },
  showLessBtn: { transform: 'rotate(180deg)' },
  checkbox: {
    padding: 1
  },
  btn: { display: 'flex', justifyContent: 'flex-start' },
  title: { color: theme.palette.grey[800], fontWeight: 500 },
  warning: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    background:
      theme.palette.type === 'dark'
        ? darken(theme.palette.warning.light, 0.8)
        : '#FFF8E1',

    gap: 4,
    border: `1px solid ${theme.palette.warning.main}`,
    borderRadius: 8,
    margin: '8px 0 8px 0'
  },
  icon: { fontSize: 14, color: theme.palette.warning.main },
  text: { fontWeight: 600 },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    fontSize: 12,
    lineHeight: '1rem',
    color: theme.palette.warning.main
  }
}))
export default useStyles
